<template>
    <div :class="['insert-rec','insert-shop-card',expiredClass,cursorClass]">  
        <a :href="linkUrl" class="insert-box sendAction padding-zero" data-spm-data="v" :data-spm-content="dataSpmContent" target="_blank" data-acode = "8888">
            <div class="external-video">
                <!-- type 37 -->
                <template v-if="type==37">
                    <div class="video-detail border-bottom-zero">
                        <h5 class="title" v-if="title">{{title}}</h5>
                        <div class="content" v-if="desc">
                            {{desc}}
                        </div>
                        <div class="insert-btn-fix fix-position" v-if="btnText">{{btnText}}</div>
                    </div>
                    <div class="sohu-video-container" @click="playVideo">
                        <img :src="image" class="bg-video play-video" :data-videoUrl="videoUrl"/>
                        <div class="play-logo play-video" :data-videoUrl="videoUrl"/>
                    </div>
                </template>
                <!-- type 38 -->
                <template v-else-if="type==38">
                    <div class="sohu-video-container" @click="playVideo">
                        <img :src="image" class="bg-video play-video" :data-videoUrl="videoUrl"/>
                        <div class="play-logo play-video" :data-videoUrl="videoUrl"/>
                    </div>
                    <div class="video-detail border-top-zero">
                        <h5 class="title" v-if="title">{{title}}</h5>
                        <div class="content" v-if="desc">
                            {{desc}}
                        </div>
                        <div class="insert-btn-fix fix-position" v-if="btnText">{{btnText}}</div>
                    </div>
                </template>
                <!-- type 39 -->
                <div class="sohu-video-container" v-else @click="playVideo">
                    <img :src="image" class="bg-video play-video" :data-videoUrl="videoUrl"/>
                    <div class="play-logo play-video" :data-videoUrl="videoUrl"/>
                </div>
            </div>
        </a>
        <div class="rec rec-widthFix" v-if="cardInfo.accountName&&cardInfo.avatar">
            <div class="rec-avator"><img :src="cardInfo.avatar"/></div>
            <div class="rec-text">{{cardInfo.accountName}}推荐</div>
            <div class="rec-expired-tag" v-if="status === 4 || status === 3">已失效</div>
        </div>
    </div>
</template>

<script>

export default {
	name: "external-video",
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {

        }
    },
    computed: {
        type() {
            return this.cardInfo?.pluginType
        },
        fields() {
            return this.cardInfo?.fields || {}
        },
        sofaInfo() {
            return this.fields?.video?.sofaPlayInfo?.[0]
        },
        image() {
            return this.fields?.video?.cover
        },
        videoUrl() {
            return this.sofaInfo?.videoUrl
        },
        title() {
            return this.fields?.title?.substring(0,26) || ''
        },
        btnText() {
            return this.fields?.btnText || ''
        },
        desc() {
            return this.fields?.desc?.substring(0,26) || ''
        },
        dataSpmContent() {
            return '||' + this.cardInfo?.uuid + '|||'
        },
        status() {
            return this.cardInfo?.status || 1
        },
        isAutoPlay() {
            if(this.status == 4 || this.status == 3)return false
            return true
        },
        expiredClass() {
            return this.status === 4 || this.status === 3 ? 'expired' : ''
        },
        linkUrl() {
            return this.fields?.linkUrl
        },
        cursorClass() {
            return this.linkUrl ? 'cursor' : ''
        }
    },
    methods: {
        playVideo(e) {
            e.preventDefault()
            var target = e.target;
            var rect = target?.parentElement?.getBoundingClientRect();
            var offset = {
                top: rect?.top + window.pageYOffset,
                left: rect?.left + window.pageXOffset
            };
            var playerDom = document.querySelectorAll('#sohu-play-content')
            if(!playerDom.length > 0) return false
            playerDom = playerDom[0]
            playerDom.style.display = "block"
            playerDom.style.left = offset.left + 'px'
            playerDom.style.top = offset.top + 'px'
            var opt = {
                el: 'sohu-play-content', // 容器ID、必填
                url: e.target.getAttribute("data-videoUrl"), // 视频链接、必填
                autoplay: true, // 自动播放、默认false
                loop: false, // 循环播放、默认false
            }
            if (!window.palyerIns) {
                import(/* webpackChunkName: "mptcfe-pc-player" */'mptcfe-pc-player').then((res) => {
                    var MptcfePCPalyer = res && res.MptcfePalyer
                    window.palyerIns = new MptcfePCPalyer(opt)
                })
            } else {
                window.palyerIns.play(opt)
            }
        }
    }
}
</script>

<style lang="less" scoped>

</style>